<template>
<div class="columns container is-fluid">
    <div class="column is-half "> 
        <div class="field">
            <label class="label">Customer Id</label>
            <div class="control">
                <input class="input" type="text" placeholder="customer id" v-model="customerId">
            </div>
        </div>

        <div class="field">
            <label class="label">Customer Name</label>
            <div class="control has-icons-left has-icons-right">
                <input class="input" type="text" placeholder="customerName" v-model="customerName" >
            </div>
        </div>

        <div class="field">
            <label class="label">Gender</label>
            <div class="control">
                <label class="radio">
                    <input type="radio" name="gender" v-model="gender" value="male"> Male
                </label>
                 <label class="radio">
                    <input type="radio"  name="gender" v-model="gender" value="female"> Female
                </label>
            </div>
        </div>
        <div class="field">
            <label class="label">Address</label>
            <div class="control has-icons-left has-icons-right">
                <input class="input" type="text" placeholder="Address" v-model="address">
            </div>
        </div>

        <div class="field">
            <label class="label">City</label>
            <div class="control has-icons-left has-icons-right">
                <input class="input" type="text" placeholder="city" v-model="city">
            </div>
        </div>

        <div class="field">
            <label class="label">State</label>
            <div class="control has-icons-left has-icons-right" >
                <input class="input" type="text" v-model="state">
            </div>
        </div>


        <div class="field">
            <label class="label">Pincode</label>
            <div class="control has-icons-left has-icons-right">
                <input class="input" type="text" v-model="pincode">
            </div>
        </div>

        <div class="field">
            <label class="label">Contact Number</label>
            <div class="control has-icons-left has-icons-right">
                <input class="input" type="text" v-model="contact">
            </div>
        </div>
        <div class="field">
            <label class="label">EmailId</label>
            <div class="control has-icons-left has-icons-right">
                <input class="input" type="email" v-model="emailId">
            </div>
        </div>

        <div class="field">
            <label class="label">GST no.</label>
            <div class="control has-icons-left has-icons-right">
                <input class="input" type="text" v-model="gstNumber">
            </div>
        </div>

        <div class="field is-grouped">
            <div class="control">
                <button class="button is-link" v-on:click="create">Submit</button>
            </div>
            <div class="control">
                <button class="button is-link is-light">Cancel</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import { createCustomer }  from '../repository'
export default {
  name: 'createCustomer',
  data(){
    return {
        customerId: '',
        customerName: '',
        gender: '',
        address: '',
        city: '',
        state: '',
        pincode: 0,
        contact: '',
        emailId:'',
        gstNumber: ''
    }
  },
  methods: {
    create(){
        let data = { customerId: this.customerId, customerName: this.customerName , 
            gender: this.gender, address: this.address, city: this.city, 
            state: this.state,
            pincode: this.pincode, contact: this.contact, emailId: this.emailId, gstNumber: this.gstNumber}
    createCustomer(data)
        .then(data => {
            this.$router.push('/getCustomers');
        })
        .catch(err => alert(err.message));
    },
  },
}
</script>
<style scoped>
#preview {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>